import { Component, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { IAbstractView } from '@core/interfaces';
import { ButtonActionPresenter } from './button-action.presenter';
import { IButtonActionComponent, IButtonActionPresenter } from './interfaces';

@Component({
	selector: 'app-button-action',
	templateUrl: './button-action.component.html',
	styleUrls: ['./button-action.component.scss'],
	imports: [CommonModule, IonicModule],
	providers: [ButtonActionPresenter],
	standalone: true,
})
export class ButtonActionComponent extends IAbstractView<IButtonActionPresenter> implements IButtonActionComponent {
	translations = this.presenter.translations;

	@Input() loading$ = this.presenter.loading$;
	@Input() disabled = this.presenter.disabled;
	@Input() text = this.presenter.text;
	@Input() textRight = this.presenter.textRight;
	@Input() icon = this.presenter.icon;
	@Output() buttonClick = this.presenter.buttonClick;

	constructor(presenter: ButtonActionPresenter) {
		super(presenter);
	}

	get hasTwoTexts(): boolean {
		return this.presenter.hasTwoTexts();
	}

	onButtonClick(): void {
		this.buttonClick.emit();
	}
}
